// Team / group video programs — each is locked to people Jill unlocks in Admin.
// To add a video: { title: '...', description: '...', videoUrl: 'https://youtu.be/...' }
export const teamPrograms = [
  {
    id: 'dignity-house',
    title: 'Dignity House',
    tagline: 'A private video program for the Dignity House community.',
    logo: '/images/dignity-house-logo.png',
    accent: '#7a6a4a',
    videos: [],
  },
  {
    id: 'sbrc',
    title: 'SBRC',
    tagline: 'A private video program for the SBRC team — Bermuda, Est. 1937.',
    logo: '/images/sbrc-crest.jpg',
    accent: '#1f2a52',
    videos: [],
  },
];

export const getTeamProgram = (id) => teamPrograms.find((p) => p.id === id);
